import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./_buildingCreationHome.scss";
import HostelRoomAttendanceSection from './HostelRoomAttendanceSection';
import BuildingCreationSection from './buildingCreationSection';
import HostelDashboardSection from './HostelDashboardSection';

const TABS = [
    { key: "dashboard",         label: "Dashboard",          icon: "fal fa-th-list" },
    { key: "buildingCreation",  label: "Building Creation",  icon: "fal fa-building" },
    { key: "studentAllocation", label: "Student Allocation", icon: "fal fa-users" },
];

class BuildingCreationHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blockType: "dashboard",
        };
    }

    handleSelect(val) {
        this.setState({
            blockType: val
        })
    }

    render() {
        const blockType = this.state.blockType;

        return (
            <div className="buildingCreationHome" style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
                <Container fluid className="px-0">
                    <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

                        {/* Modern tab header */}
                        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
                            <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                                {TABS.map((tab) => {
                                    const isActive = blockType === tab.key;
                                    return (
                                        <li className="nav-item" key={tab.key}>
                                            <a
                                                className={`nav-link ${isActive ? "active" : ""}`}
                                                href="#"
                                                onClick={(e) => { e.preventDefault(); this.handleSelect(tab.key); }}
                                                style={{
                                                    cursor: "pointer",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    padding: "12px 20px",
                                                    color: isActive ? "#6366f1" : "#4b5563",
                                                    background: isActive ? "#fff" : "transparent",
                                                    borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                                    borderWidth: "1.5px",
                                                    borderBottomWidth: isActive ? "2px" : "1.5px",
                                                    borderRadius: "10px 10px 0 0",
                                                    transition: "all 0.15s ease",
                                                    marginBottom: "-1.5px",
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <i className={tab.icon} />
                                                {tab.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {/* Content panel */}
                        <div style={{ padding: "28px" }}>
                            {blockType === "buildingCreation" && (
                                <BuildingCreationSection
                                    globals={this.props.globals}
                                    getNewEducationalStudents={this.props.getNewEducationalStudents}
                                    studentCreationModal={this.state.studentCreationModal}
                                />
                            )}
                            {blockType === "studentAllocation" && (
                                <HostelRoomAttendanceSection
                                    globals={this.props.globals}
                                    getNewEducationalStudents={this.props.getNewEducationalStudents}
                                    studentCreationModal={this.state.studentCreationModal}
                                />
                            )}
                            {blockType === "dashboard" && (
                                <HostelDashboardSection
                                    globals={this.props.globals}
                                />
                            )}
                        </div>

                    </div>
                </Container>
            </div>
        );
    }
}
export default BuildingCreationHome;
